import { useParams } from "react-router-dom";
import { useApp } from "@/context/AppContext";

export default function Policies() {
  const { kind } = useParams();
  const { settings } = useApp();
  const s = settings || {};
  const map = {
    "shipping": { title: "Shipping Information", body: s.shipping_policy },
    "privacy": { title: "Privacy Policy", body: s.privacy_policy },
    "terms": { title: "Terms & Conditions", body: s.terms_policy },
    "order-issues": { title: "Need Help With Your Order?", body: s.returns_policy },
  };
  const p = map[kind] || map.shipping;
  return (
    <div className="max-w-3xl mx-auto px-4 md:px-8 py-10 md:py-16">
      <div className="overline text-[#E63946] mb-3">Policy</div>
      <h1 className="font-display text-3xl md:text-5xl tracking-tighter mb-8">{p.title}</h1>
      <div className="text-white/80 whitespace-pre-line leading-relaxed">{p.body}</div>
      {kind === "order-issues" && (
        <div className="mt-8 flex gap-3">
          <a href={`https://wa.me/91${s.whatsapp}`} target="_blank" rel="noreferrer" className="sa-btn sa-btn-primary">WhatsApp Us</a>
          <a href="/contact" className="sa-btn sa-btn-outline">Contact Us</a>
        </div>
      )}
    </div>
  );
}
